import Support from './Support';
import dummy from './dummy';

let support = null;
if (__SUPPORT__ && !window.isConsultPortal) {
  support = Support;
} else {
  support = dummy;
}

export default support;

